import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
// Service would normally be imported, but assuming we pass actions or use a hook
// import { notificationService } from '../../services/notificationService'; // Placeholder

export const GlobalPopup = ({ notifications, actions }) => {
    const [currentPopup, setCurrentPopup] = useState(null);
    const [show, setShow] = useState(false);
    // Track locally processed popups to allow sequential display
    const [processedIds, setProcessedIds] = useState(new Set());

    useEffect(() => {
        // Filter notifications to find the next valid popup
        const nextPopup = notifications.find(n => {
            // Skip already processed popups in this session component lifecycle
            if (processedIds.has(n.id)) return false;

            // Ya no es necesario filtrar por tipo - todas las notificaciones son Popup

            // Filter by Date
            const now = new Date();
            const start = n.datos.fechaInicio ? new Date(n.datos.fechaInicio) : null;
            const end = n.datos.fechaFin ? new Date(n.datos.fechaFin) : null;

            if (start && now < start) return false;
            if (end && now > end) return false;

            // Filter by Acceptance/Read status (handled by backend mostly, but double check)
            // If requires acceptance, rely on backend sending it (meaning not accepted yet).
            // If session based (frecuencia === 1), check sessionStorage
            if (n.datos.frecuencia === 1) {
                if (sessionStorage.getItem(`popup_seen_${n.id}`)) return false;
            }

            return true;
        });

        if (nextPopup) {
            setCurrentPopup(nextPopup);
            setShow(true);
        }
    }, [notifications, processedIds]);

    const markAsProcessed = (id) => {
        setProcessedIds(prev => {
            const newSet = new Set(prev);
            newSet.add(id);
            return newSet;
        });
    };

    const handleClose = (e) => {
        if (e) e.preventDefault();
        if (!currentPopup) return;

        // Mark as processed locally so it doesn't show again immediately
        markAsProcessed(currentPopup.id);

        // Logic based on frequency
        if (currentPopup.datos.frecuencia === 1) {
            // Session based: mark in storage, don't tell backend to hide forever (unless it's just 'read')
            sessionStorage.setItem(`popup_seen_${currentPopup.id}`, 'true');
            setShow(false);
        } else {
            // Once / Permanent: Call API to mark as read/closed.
            // Safely call action if it exists
            if (actions && actions.handleMarkAsRead) {
                actions.handleMarkAsRead(currentPopup);
            }
            setShow(false);
        }
    };

    const handleAccept = () => {
        if (!currentPopup) return;

        // Mark as processed locally
        markAsProcessed(currentPopup.id);

        // Check frequency setting
        if (currentPopup.datos.frecuencia === 1) {
            // Session-based: only save in sessionStorage, don't persist in DB
            sessionStorage.setItem(`popup_seen_${currentPopup.id}`, 'true');
        } else {
            // Permanent: save in database via API
            actions.handleAccept(currentPopup);
        }

        setShow(false);
    };

    if (!currentPopup) return null;

    const isBlocking = currentPopup.datos.requiereAceptacion;

    return (
        <Modal show={show} onHide={isBlocking ? undefined : handleClose} backdrop={isBlocking ? 'static' : true} keyboard={!isBlocking} centered size="lg">
            <Modal.Header closeButton={!isBlocking}>
                <Modal.Title>{currentPopup.datos.titulonotificacion}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: currentPopup.datos.descripcion }} />
                {currentPopup.datos.imagenbanner && currentPopup.datos.imagenbanner.trim() && (
                    <img src={currentPopup.datos.imagenbanner} alt="Banner" className="img-fluid mt-3" />
                )}
            </Modal.Body>
            <Modal.Footer>
                {!isBlocking && (
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                )}
                {/* Hide Accept button for non-blocking session popups, user only wants Close option */}
                {!(currentPopup.datos.frecuencia === 1 && !isBlocking) && (
                    <Button variant="primary" onClick={handleAccept}>
                        {isBlocking ? 'Aceptar y Continuar' : 'Entendido'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};
